<template>
  <v-container>
    <v-row
      class="ma-0"
    >
      <v-expansion-panels
        v-model="openedPanels"
        multiple
        focusable
      >
        <processing-results-panel/>
        <post-processing-requests-panel
          ref="post-processing-requests-panel"
          v-if="cannot(['^(PRO2)', '^(BUSINESS2)'])"
        />
        <post-processings-results-panel
          ref="post-processings-results-panel"
          v-if="cannot(['^(PRO2)', '^(BUSINESS2)'])"
        />
      </v-expansion-panels>
    </v-row>
  </v-container>
</template>

<script>
  import ProcessingResultsPanel from "./ProcessingResults/ProcessingResultsPanel"
  import PostProcessingRequestsPanel from "./PostProcessingRequests/PostProcessingRequestsPanel"
  import PostProcessingsResultsPanel from "./PostProcessingResults/PostProcessingsResultsPanel"
  import {remove} from "lodash/array"
  import {eq} from "lodash/lang"
  // import { ConpassEventBus } from '../../../helpers/conpass/events'
  import {listSubscription} from "../../../api/api-billing"


  const PANEL_OPTIONS = {
    PROCESSING_RESULTS_PANEL: 0,
    POST_PROCESSINGS_REQUESTS_PANEL: 1,
    POST_PROCESSINGS_RESULTS_PANEL: 2,
  }

  export default {
    name: "MainPanel",
    data: () => ({
      openedPanels: [],
      subscriptions: [],
    }),
    components: {PostProcessingsResultsPanel, PostProcessingRequestsPanel, ProcessingResultsPanel},
    created () {
      // ConpassEventBus.$on("startflow", this.onStartFlow)

      listSubscription(this.$apiAuth.getAuthToken())
        .then(res => this.subscriptions = res.data.data)
    },
    computed: {
      items() {
        return PANEL_OPTIONS
      }
    },
    methods: {
      onStartFlow() {
        if (this.openedPanels.includes(PANEL_OPTIONS.POST_PROCESSINGS_REQUESTS_PANEL)) {
            remove(this.openedPanels, x => eq(x, PANEL_OPTIONS.POST_PROCESSINGS_REQUESTS_PANEL))
            this.$refs["post-processing-requests-panel"].onChange()
        } else if (this.openedPanels.includes(PANEL_OPTIONS.POST_PROCESSINGS_RESULTS_PANEL)) {
            remove(this.openedPanels, x => eq(x, PANEL_OPTIONS.POST_PROCESSINGS_RESULTS_PANEL))
            this.$refs["post-processings-results-panel"].onChange()
        }
        this.openedPanels.splice(0, this.openedPanels.length)
      },
      cannot(subscriptions) {
        if (!this.subscriptions.length)
          return false

        const searchForSubscription = this.subscriptions.filter((subscription) => {
          const { ab_subscription_plan } = subscription['subscription_plan']

          const subscriptionPlanAllowed = subscriptions.some((sub) => 
            new RegExp(sub).test(ab_subscription_plan)
          )

          return subscriptionPlanAllowed
        })

        return !searchForSubscription.length
      }
    },
    watch: {
      openedPanels(newValue, oldValue) {
        if (oldValue.includes(PANEL_OPTIONS.POST_PROCESSINGS_REQUESTS_PANEL)) {
          if (newValue.includes(PANEL_OPTIONS.POST_PROCESSINGS_RESULTS_PANEL)) {
            remove(this.openedPanels, x => eq(x, PANEL_OPTIONS.POST_PROCESSINGS_REQUESTS_PANEL))
            this.$refs["post-processing-requests-panel"].onChange()
          }
        } else if (oldValue.includes(PANEL_OPTIONS.POST_PROCESSINGS_RESULTS_PANEL)) {
          if (newValue.includes(PANEL_OPTIONS.POST_PROCESSINGS_REQUESTS_PANEL)) {
            remove(this.openedPanels, x => eq(x, PANEL_OPTIONS.POST_PROCESSINGS_RESULTS_PANEL))
            this.$refs["post-processings-results-panel"].onChange()
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>
